module.exports = __webpack_public_path__ + "img/L_318_326.1ab83cec.png";